/* DEFAULT
 * The DraftManagement component
 *
 * @param  {function}  saveDraft   - save draft function which runs on click
 */
//NPM LIBRARIES
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
//COMPONENTS AND UTILITIES
import AUbutton from '@gov.au/buttons';

const DraftManagement = (props) => {
    const onSaveDraftClick = (e) => {
        e.preventDefault();
        props.saveDraft();
    }

    return (
        <Fragment>
            <hr />
            <div className="form-controls">
                <AUbutton
                    id="SaveDraft"
                    as="secondary"
                    onClick={(evt) => onSaveDraftClick(evt)}>
                    Save and exit application
                </AUbutton>
            </div>
        </Fragment>
    );
}

DraftManagement.propTypes = {
    saveDraft: PropTypes.func
};

export default DraftManagement;

